<script setup>
import { inject, ref } from 'vue';

const emit = defineEmits(['done']);
const dataView = inject('dataView');
const loading = ref(false);

const submit = ({ dirtyData }) => {
    dataView.activeView.setFilters(Object.keys(dirtyData).length ? dirtyData : undefined);

    loading.value = true;

    dataView.activeView.fetch().then(() => emit('done')).finally(() => loading.value = false);
}
</script>

<template>
    <app-form v-slot="{ form }" :submit-using="submit">
        <div class="flex items-center justify-between">
            <h2 class="text-sm font-semibold mb-2">Filters</h2>

            <app-text-button type="button" @click="form.reset()">Reset</app-text-button>
        </div>
        <app-form-grid>
            <component
                v-for="filter in dataView.activeView.filters"
                :is="filter.componentName()"
                :name="filter.name"
                :label="filter.label"
                v-bind="filter.props"
                @hydrated:state="({ field }) => {
                    if (filter.name in (dataView.activeView.query?.f ?? {})) {
                        field.updateState({ value: dataView.activeView.query.f[field.name] });
                    }
                }"
                />

                <div class="flex justify-end gap-4 w-full">
                    <app-button compact capitalize type="button" @click="emit('done')">
                        Cancel
                    </app-button>
                    <app-button compact capitalize color="primary" :loading="loading">
                        Apply
                    </app-button>
                </div>
        </app-form-grid>
    </app-form>
</template>
